export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12039.7f5e0e7f.jpg";